import React from 'react';
import { collection, doc, query, where, getDocs, setDoc } from 'firebase/firestore';
import { firestore } from '../../../../config/firebase';
import { Button, Col, Form, Input, Modal, Row, Space, Tooltip, message } from 'antd';
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { useEffect, useState } from 'react';
const initialState = { title: "", category: "", description: "", price: "", duration: '' }

export default function AdminCourse() {
    const [state, setState] = useState(initialState);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenForUpdate, setIsModalOpenForUpdate] = useState(false);
    const [coursesData, setcoursesData] = useState([]);

    const truncateStringTo10Words = (inputString) => {
        const words = inputString.split(' ');
        const truncatedString = words.slice(0, 10).join(' ');
        return truncatedString + ' . . . .';
    };
    const deletecourse = async (course) => {
        let deletedcourse = { ...course, status: "deleted" }
        try {
          await setDoc(doc(firestore, "courses", deletedcourse.courseId), deletedcourse);
          let coursesDataAfterDelete = coursesData.filter((course) => course.courseId !== deletedcourse.courseId)
          setcoursesData(coursesDataAfterDelete)
          message.success("The course Deleted successfully")
        } catch (e) {
          console.error("Error adding document: ", e);
        }
      }
    const handleChange = (e) => {
        setState((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    };

    const addcourseToFirestore = async (courseData) => {
        try {
            await setDoc(doc(firestore, 'courses', courseData.courseId), courseData);
            setcoursesData([courseData, ...coursesData]);
            message.success('The course Added successfully');
            setIsModalOpen(false);
        } catch (error) {
            console.error('Error adding document: ', error);
        }
    };

    const handleUpdatecourse = async () => {
        const updatedCoursesData = coursesData.map((course) => {
            if (course.courseId === state.courseId) {
              return { ...course, ...state };
            }
            return course;
          });
          try {
            await setDoc(doc(firestore, 'courses', state.courseId), state);
            setcoursesData(updatedCoursesData);
            message.success('The course Updated successfully');
            setIsModalOpenForUpdate(false);
          }
          catch (error) {
            console.error('Error updating document: ', error);
          }
    };

    const handleAddcourse = () => {
        const courseId = Math.random().toString(36).slice(2);

        const courseData = {
            ...state,
            createdAt: new Date().toLocaleString(),
            courseId,
            status: 'active',
        };

        if (!courseData.title || !courseData.category || !courseData.description || !courseData.price || !courseData.duration) {
            message.error('FILL ALL INPUTS');
            return;
        }

        addcourseToFirestore(courseData);
    };


    useEffect(() => {
        // Fetch courses data from Firestore when component mounts
        const getcoursesFromFirestore = async () => {
            const q = query(collection(firestore, 'courses'), where('status', '==', 'active'));
            const querySnapshot = await getDocs(q);
            const array = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                array.push(data);
            });
            setcoursesData(array);
        };

        getcoursesFromFirestore();
    }, []);
    return (
        <>
            <h1 className=' text-[#fffa8a] pt-24 font-bold text-[48px] text-center italic'>All courses Table</h1>
            <div className="flex justify-content-center  mt-5">
                <Button
                    
                    className="px-10  text-center rounded-2xl mx-auto  hover:rounded-lg"
                    style={{ background: "transparent", border: "1px solid #fffa8a", color: "#fffa8a" }} onClick={() => setIsModalOpen(true)}
                >
                    Add course
                </Button></div>
            <div className="container max-w-[90%]  text-[#fffa8a] px-4 mx-auto sm:px-8"  style={{ background: "transparent" }}>
                <div className="py-8">
                    <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
                        <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
                            <table className="min-w-full leading-normal">
                                <thead>
                                    <tr>
                                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                            Title
                                        </th>
                                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                            Category
                                        </th>
                                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                       Price
                                        </th>
                                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                       Duration
                                        </th>
                                        
                                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                            Description
                                        </th>
                                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {coursesData.map((rowData, index) => (
                                        <tr key={index}>
                                            <td className="px-5 py-5 text-sm  border-b text-left border-[#fffa8a] text-[#fffa8a]">
                                                <div className="flex items-center">
                                                    <div>
                                                        <p className=" whitespace-no-wrap">{rowData.title}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                <p className=" whitespace-no-wrap">{rowData.category}</p>
                                            </td>
                                            <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                <p className=" whitespace-no-wrap">{rowData.price}</p>
                                            </td>
                                            <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                <p className=" whitespace-no-wrap">{rowData.duration}</p>
                                            </td>
                                            <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                {truncateStringTo10Words(rowData.description)}
                                            </td>
                                            <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                <Space>
                                                    <Tooltip title="Delete" color='red'  ><Button onClick={() => deletecourse(rowData)} danger icon={<DeleteOutlined />} /></Tooltip>
                                                    <Tooltip title="Edit"  ><Button type="primary" icon={<EditOutlined className='text-[#fffa8a]' onClick={() => {
                                                        setIsModalOpenForUpdate(true)
                                                        setState(rowData)
                                                    }} />} /></Tooltip>
                                                </Space>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            );
            <Modal
                title="ADD course"
                centered
                open={isModalOpen}
                onOk={handleAddcourse}
                okText="Confirm"
                okButtonProps={{ type: 'primary', color: "primary", className: ' text-center rounded-2xl text-black   hover:rounded-lg ' }}
                cancelText="Close"
                onCancel={() => setIsModalOpen(false)}
                style={{ maxWidth: 1000 }}
            >
                <Form layout="vertical" className='py-4'>
                    <Row gutter={16}>
                        <Col xs={24} lg={12}>
                            <Form.Item label="Title">
                                <Input placeholder='Input your title' name='title' onChange={handleChange} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Form.Item label="Category">
                                <Input placeholder='Enter the Category' name='category' onChange={handleChange} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Form.Item label="Price">
                                <Input placeholder='Enter the price' name='price'  onChange={handleChange} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Form.Item label="Duration">
                                <Input placeholder='Enter the duration in days' name='duration'  onChange={handleChange} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Description" className='mb-0'>
                                <Input.TextArea placeholder='Input your description' name='description' onChange={handleChange} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <div className="flex justify-content-center">
                        <Button onClick={handleAddcourse} className='mx-auto mt-5 text-center'>Add course</Button></div>
                </Form>
            </Modal>
            <Modal
                title="Update course"
                centered
                open={isModalOpenForUpdate}
                onOk={handleUpdatecourse}
                okText="Confirm"
                okButtonProps={{ type: 'primary', color: "primary", className: ' text-center rounded-2xl text-black   hover:rounded-lg ' }}
                cancelText="Close"
                onCancel={() => setIsModalOpenForUpdate(false)}
                style={{ maxWidth: 1000 }}
            >
                <Form layout="vertical" className='py-4'>
                    <Row gutter={16}>
                        <Col xs={24} lg={12}>
                            <Form.Item label="Title">
                                <Input placeholder='Input your title' name='title' value={state.title} onChange={handleChange} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Form.Item label="Category">
                                <Input placeholder='Enter the Category' name='category' value={state.category} onChange={handleChange} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Form.Item label="Price">
                                <Input placeholder='Enter the price' name='price' value={state.price} onChange={handleChange} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Form.Item label="Duration">
                                <Input placeholder='Enter the duration in days' name='duration' value={state.duration} onChange={handleChange} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="Description" className='mb-0'>
                                <Input.TextArea placeholder='Input your description' value={state.description} name='description' onChange={handleChange} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <div className="flex justify-content-center">
                        <Button onClick={handleUpdatecourse} className='mx-auto mt-5 text-center'>Update course</Button></div>
                </Form>
            </Modal>
        </>
    )
}
